import { invoiceTypesObj, enrollPrograms, paymentStatus, EnrollStatus, Status, recordStatus, scholarshipTypes } from 'src/app/dummy/status';
import { ConvertService } from 'src/app/services/convert.service';
import { MatSnackBar } from '@angular/material';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { Student } from 'src/app/stores/student.store';
import { Payment } from 'src/app/stores/payment.store';
import { Environment } from 'src/app/stores/environment.store';
import { MappingService, academicYearObj } from 'src/app/services/mapping.service';
import { DataService } from 'src/app/services/data.service';
import { Invoice } from 'src/app/stores/invoice.store';
import { IInvoice } from 'src/app/interfaces/invoice';

@Component({
  selector: 'app-add-miscellaneous-invoice',
  templateUrl: './add-miscellaneous-invoice.component.html',
  styleUrls: ['./add-miscellaneous-invoice.component.scss']
})
export class AddMiscellaneousInvoiceComponent implements OnInit {
  form: FormGroup;
  fee: AbstractControl;

  dataLists = [];
  constructor(
    public dialogRef: MatDialogRef<AddMiscellaneousInvoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    public store: Payment,
    public ds: DataService,
    public env: Environment,
    public studentStore: Student,
    public invoice: Invoice
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      fee: [null, Validators.required],
    })
    this.fee = this.form.controls['fee'];
  }

  currentYear: any;
  async ngOnInit() {
    this.buildForm();
    this.store.fetchMiscellaneousFee();
    const {selectedSchool} = this.env
    const envData: any = await this.env.fetchAcademicEnv(selectedSchool.key);
    this.currentYear = envData.year;
  }

  create(f: any) {
    if (this.form.valid) {
      if (f.fee.length === 0) return;
      this.form.disable();
      const date = new Date();
      const create_by = MappingService.userObj(this.env.user);
      let array = [];
      f.fee.forEach(doc => {
        let { program_academic } = this.studentStore.student;
        const item: IInvoice = {
          key: this.ds.createId(),
          create_date: date,
          create_date_key: ConvertService.toDateKey(date),
          create_by: create_by,
          issue_by: create_by,
          issue_date: date,
          invoice_no: null,
          invoice_type: invoiceTypesObj.miscellaneous,
          school_fee_type: enrollPrograms.academic,
          student: MappingService.studentObj(this.studentStore.student),
          verify_by: create_by,
          verify_date: date,
          page_key: ConvertService.pageKey(),
          verify_date_key: ConvertService.toDateKey(date),
          invoice_date: date,
          invoice_date_key: ConvertService.toDateKey(date),
          course: doc,
          isPaid: paymentStatus.unpaid,
          isVoid: false,
          program: program_academic,
          byAdmission: false,
          issue_year: academicYearObj(this.currentYear),
          payment_year: null,
          headerRef: null,
          isHeader: false,
          enroll_status: null,
          isEnrollVerify: true,
          campus: MappingService.campusObj(this.env.campus),
          schoolSession: null,
          description: doc.name,

          penaltyRef: null,
          penalty: null,
          scholarshipRef: null,
          scholarship: null,
          loan: null,
          prepaidRef: null,
          prepaid: null,
          price: doc.price,
          amount: doc.price,
        }
        array.push(item);
      })

      const { first_penalty_fee, second_penalty_fee } = this.env.config;
      let penaltyData = [];
      if (first_penalty_fee && second_penalty_fee) {
        penaltyData = array.filter(m => m.course.key === first_penalty_fee.key || m.course.key === second_penalty_fee.key);
      }

      if (penaltyData.length > 0 && this.store.paymentHeader) {
        const { invoiceKey, paymentHeader } = this.store;
        const header = invoiceKey ? this.invoice.paymentHeader : paymentHeader
        this.store.addPenaltyFee(penaltyData[0], this.studentStore.student, header, (success, error) => {
          if (success) {
            this.snackBar.open("Penalty has been added to invoice.", "Done", { duration: 2000 })
            this.dialogRef.close('yes');
            this.form.enable();
          }
          else {
            this.snackBar.open(error, "Error");
            this.form.enable();
          }
        })
      } else {
        const { invoiceKey, paymentHeader } = this.store;
        const header = invoiceKey ? this.invoice.paymentHeader : paymentHeader
        this.store.addMiscellaneousFee(array, this.studentStore.student, header, (success, error) => {
          if (success) {
            this.snackBar.open("Miscellaneous has been added to invoice.", "Done", { duration: 2000 })
            this.dialogRef.close('yes');
            this.form.enable();
          }
          else {
            this.snackBar.open(error, "Error");
            this.form.enable();
          }
        })
      }
    }
  }
}